import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouteStore } from '../stores/data/store';
export default function useRouteTracker() {
  const $ = _c(8);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const pushPath = useRouteStore(_temp);
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t0 = searchParams?.toString() ? `${pathname}?${searchParams?.toString()}` : pathname;
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fullPath = t0;
  const prevFullPathRef = useRef(null);
  let t1;
  let t2;
  if ($[3] !== fullPath || $[4] !== pathname || $[5] !== pushPath) {
    t1 = () => {
      const {
        isGoingBack,
        setIsGoingBack
      } = useRouteStore.getState();
      setIsGoingBack(false);
      if (isGoingBack) {
        prevFullPathRef.current = fullPath;
        return;
      }
      if (prevFullPathRef.current !== null) {
        const prevPathname = prevFullPathRef.current.split("?")[0];
        if (prevPathname !== pathname) {
          pushPath(prevFullPathRef.current);
        }
      }
      prevFullPathRef.current = fullPath;
    };
    t2 = [fullPath, pathname, pushPath];
    $[3] = fullPath;
    $[4] = pathname;
    $[5] = pushPath;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
}
function _temp(s) {
  return s.pushPath;
}